import React, { useEffect } from 'react';
import api from '@api/api';
import {
  SuitabilityInfo,
  ForeignCurrencySuitabilityInfo,
} from '@container/customer';

const SuitabilityField = ({
  type,
  userInfo,
  customerInfo,
  updateCustomerInfo,
  postSuitability,
  postSuitabilityByPlan,
  chkCertiSms,
  verifySmsAuthNo,
  retrySmsAuthNo,
  verifyName,
  checkIdentityCard,
  saveSignNameData,
  saveSignatureData,
  sendTestSms,
  showModal,
  getSuitabilityTestHistory,
  getSuitabilityKeys,
  postSuitabilityReport,
  searchCustomerByCustNo,
  setCustomerState,
  onComplete,
}) => {
  const renewSuitability = async () => {
    const custNo = customerInfo?.custNo;
    if (custNo) {
      const isUsd = type === 'currency' ? 1 : 0;
      const { status, data } = await api.getSuitabilityLately({
        params: { custNo, isUsd },
      });

      if (status === 200) {
        const suitabilityKey = isUsd === 1 ? 'usdSuitability' : 'suitability';
        updateCustomerInfo({ [suitabilityKey]: data });
      }
    }
  };

  // 적합성 진단 정상 완료(isComplete) 시, 적합성 내역 업데이트
  const handleComplete = async isComplete => {
    if (isComplete) await renewSuitability();
    if (typeof onComplete === 'function') onComplete(isComplete);
  };

  useEffect(renewSuitability, [customerInfo.custNo]);

  return type === 'variable' ? (
    <SuitabilityInfo
      userInfo={userInfo}
      customerInfo={customerInfo}
      updateCustomerInfo={updateCustomerInfo}
      postSuitability={postSuitability}
      postSuitabilityByPlan={postSuitabilityByPlan}
      chkCertiSms={chkCertiSms}
      verifySmsAuthNo={verifySmsAuthNo}
      retrySmsAuthNo={retrySmsAuthNo}
      verifyName={verifyName}
      checkIdentityCard={checkIdentityCard}
      saveSignNameData={saveSignNameData}
      saveSignatureData={saveSignatureData}
      sendTestSms={sendTestSms}
      showModal={showModal}
      getSuitabilityTestHistory={getSuitabilityTestHistory}
      getSuitabilityKeys={getSuitabilityKeys}
      postSuitabilityReport={postSuitabilityReport}
      searchCustomerByCustNo={searchCustomerByCustNo}
      setCustomerState={setCustomerState}
      onComplete={handleComplete}
    />
  ) : (
    <ForeignCurrencySuitabilityInfo
      userInfo={userInfo}
      customerInfo={customerInfo}
      updateCustomerInfo={updateCustomerInfo}
      postSuitability={postSuitability}
      postSuitabilityByPlan={postSuitabilityByPlan}
      chkCertiSms={chkCertiSms}
      verifySmsAuthNo={verifySmsAuthNo}
      retrySmsAuthNo={retrySmsAuthNo}
      verifyName={verifyName}
      checkIdentityCard={checkIdentityCard}
      saveSignNameData={saveSignNameData}
      saveSignatureData={saveSignatureData}
      sendTestSms={sendTestSms}
      showModal={showModal}
      getSuitabilityTestHistory={getSuitabilityTestHistory}
      getSuitabilityKeys={getSuitabilityKeys}
      postSuitabilityReport={postSuitabilityReport}
      searchCustomerByCustNo={searchCustomerByCustNo}
      setCustomerState={setCustomerState}
      onComplete={handleComplete}
    />
  );
};

SuitabilityField.defaultProps = {
  type: 'variable',
};

export default SuitabilityField;
